angular.module("siter.io").controller "EditTemplateController", ["$scope","$rootScope", "$modalInstance", "Site", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "template", "$http", "mainTemplate", ($scope, $rootScope, $modalInstance, Site, Translit, FileUploader, Restangular, $state, $cookies, template, $http, mainTemplate) ->

  $scope.site = template
  $scope.mainTemplate = mainTemplate

  $scope.site.tags = _.map $scope.site.tags.split(","), (tag, index) -> {text: tag, id: index}
  $scope.site.colors = _.map $scope.site.colors, (tag, index) -> {text: tag, id: index}

  # Transilteration functions

  $scope.transliterate = (text, entorus = false)->
    Translit.one text, entorus

  $scope.transliterate_3 = (text, entorus = false)->
    Translit.three text, entorus

  Restangular.all('/templates/tags').getList().then (items) ->
    $scope.items = _.map items, (item, index) -> {text: item, id: index}

  $scope.loadTags = (query) ->
    Restangular.all('/templates/tags').getList()

  $scope.loadColorTags = (query) ->
    Restangular.all("/templates/color_tags?q=#{query}").getList()

  # Close

  $scope.landing = {}
  $scope.cancel = ->
    $modalInstance.dismiss "cancel"

  $scope.clone = ->
    $scope.cloning = true
    Site.clone(template.id).then (data) ->
      $scope.cloning = false
      $scope.close()
      $rootScope.$broadcast "site:created", data, template

  # Preview web uploader

  $scope.webPreviewUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+"/sites/#{template.id}"
    autoUpload: false
    method: "PUT"
    alias: "preview"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  $scope.webPreviewUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.webPreviewUploader.onSuccessItem = (fileItem, response, status, headers) ->
    template.preview = response.preview
    $scope.webPreviewUploader.clearQueue()
    return

  $scope.webPreviewUploader.onErrorItem = (fileItem, response, status, headers) ->
    return

  $scope.mobilePreviewUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+"/sites/#{template.id}"
    autoUpload: false
    method: "PUT"
    alias: "mobile_preview"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  # Preview mobile uploader

  $scope.mobilePreviewUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.mobilePreviewUploader.onSuccessItem = (fileItem, response, status, headers) ->
    template.mobile_preview = response.mobile_preview
    $scope.mobilePreviewUploader.clearQueue()
    return

  $scope.mobilePreviewUploader.onErrorItem = (fileItem, response, status, headers) ->
    return

  # Creating site

  $scope.saving = false

  $scope.saveTemplate = (land, editTemplateForm) ->
    return false if editTemplateForm.$invalid
    $scope.saving = true
    land = angular.copy land
    land.is_template = true
    land.tags = _.map land.tags, (tag) ->  tag.text
    land.tags = land.tags.join(",")
    land.colors = _.map land.colors, (tag) ->  tag.text

    Site.update(land).then (new_site) ->
      template.slug = new_site.slug
      template.subdomain = new_site.subdomain
      $scope.saving = false
      $scope.mobilePreviewUploader.uploadAll()
      $scope.webPreviewUploader.uploadAll()
      $scope.close()
      $rootScope.$broadcast "site:updated"
    , (errors) ->
      $scope.errors = errors.data.errors
      $scope.saving = false


  # Close

  $scope.close = ->

    $modalInstance.dismiss "close"
]



// WEBPACK FOOTER //
// ./src/app/site/edit_template.controller.coffee